module.exports = __webpack_public_path__ + "img/bannerPc-2-3.fedc0736.png";